import { combineReducers } from 'redux';

import { IEntityActions } from '../../../../../data/store';

export const loading = (state = false, action: IEntityActions = {} as any) => {
	switch (action.type) {
		case 'PROPERTY_GET_BY_ID_REQUEST':
			return true;
		case 'PROPERTY_GET_BY_ID_RECEIVE':
		case 'PROPERTY_GET_BY_ID_FAILURE':
			return false;
		default:
			return state;
	}
};

export interface IAdminBookingCreateViewState {
	loading: ReturnType<typeof loading>;
}

export default combineReducers<IAdminBookingCreateViewState>({
	loading
});
